import React, { Component } from 'react';
import './styles.css';

class GreyCentralCircle extends Component {
	render() {
		return (
			<div className="stepper-item-layout-grey-central-circle">
				{this.props.children}
			</div>
		);
	}
}

export default GreyCentralCircle;
